

<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title">
                                    <h4 class="mb-4">Registeration</h4>
                                    <p>Fill the below form to create a new account.</p>
                                </div>
                                 <span class="text-danger text-sm">{{errorMessage }}</span>
                                <div class="clearfix">
                                    <vs-input
                                        v-validate="'required'"
                                        data-vv-validate-on="blur"
                                        label-placeholder="Clinic Name"
                                        name="clinicname"
                                        placeholder="Clinic Name"
                                        v-model="clinicname"
                                        class="w-full" />
                                    <span class="text-danger text-sm">{{ errors.first('username') }}</span>
                                           <vs-input
                                        type="text"
                                        v-validate="'required'"
                                        data-vv-validate-on="blur"
                                        data-vv-as="username"
                                        name="username"
                                        label-placeholder="Username"
                                        placeholder="Username"
                                        v-model="username"
                                        class="w-full mt-6" />
                  <select v-model="clinicTypeId" class=" vs-select--input myselect mt-6" placeholder="Phone Number" name="clinicType" style="height: 36px;" v-validate="'required'" >
                    <option v-for="(item,index) in clinicType" v-bind:key="index" :value="item.id">{{item.name}}</option>
                </select>
                 <vs-input
                                        type="text"
                                        v-validate="'min:10|max:11|numeric'"
                                        data-vv-validate-on="blur"
                                        data-vv-as="phoneNumber"
                                        name="phoneNumber"
                                        label-placeholder="Phone Number"
                                        placeholder="Phone Number"
                                        v-model="phoneNumber"
                                        class="w-full mt-6" />
                                               <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
              
                  <select v-model="areaId"  class=" vs-select--input myselect mt-6" name="location" style="height: 36px;" v-validate="'required'" >
                 
                  <option v-for="(item,index) in areaList" v-bind:key="index" :value="item.id">{{item.name}}</option>
                </select>
                  <span class="text-danger text-sm">{{ errors.first('location') }}</span>
                                    <vs-input
                                        ref="password"
                                        type="password"
                                        data-vv-validate-on="blur"
                                        v-validate="'required'"
                                        name="password"
                                        label-placeholder="Password"
                                        placeholder="Password"
                                        v-model="password"
                                        class="w-full mt-6" />
                                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                    <vs-input
                                        type="password"
                                        v-validate="'confirmed:password'"
                                        data-vv-validate-on="blur"
                                        data-vv-as="password"
                                        name="confirm_password"
                                        label-placeholder="Confirm Password"
                                        placeholder="Confirm Password"
                                        v-model="confirm_password"
                                        class="w-full mt-6" />
                                    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

                                   
                                    <vs-button class=" mt-6" @click="sendOtp" :disabled="!validateForm" >Register</vs-button>
                                    <vs-button  type="border" to="/pages/login" class="mt-6 float-right">Login</vs-button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
          <div class="demo-alignment">

    

    <vs-popup class="holamundo" title="OTP" :active.sync="popupActive">
      <p>Please enter the otp send to your mobile number</p>
        <span class="text-danger text-sm">{{otpError }}</span>
       <vs-input
                                        type="text"
                                        
                                        data-vv-validate-on="blur"
                                        data-vv-as="Otp"
                                        name="otp"
                                        label-placeholder="Otp"
                                        placeholder="Otp"
                                        v-model="otp"
                                        class="mt-6" />
        <vs-button class="float-left mt-2" @click="registerClinic" :disabled="!validateOtp" >Submit</vs-button>

    </vs-popup>
  </div>
 
    </div>
</template>

<script>
export default {
    data() {
        return {
            clinicname: '',
            password: '',
            confirm_password: '',
            areaList:[{id:"",name:'Select'}],
            username:'',
            areaId:"",
            popupActive:false,
            clinicType:[{id:"1",name:"Clinic"},{id:"2",name:"Hospital"}],
            clinicTypeId:"1",
            phoneNumber:"",
            otp:'',
            otpError:'',
            errorMessage:''
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.clinicname != '' && this.username != '' && this.areaId != ''&& this.password != ''&& this.phoneNumber != '' && this.confirm_password != '' ;
        },
        validateOtp(){
            return this.otp !='' ;
        }
    },
    mounted() {
        this.getAreaList();
    },
    methods: {
         getAreaList() {
          
            this.$http.post(
                    "getlocationlist",
                     {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    response.data.data.forEach((value) => {
                        this.areaList.push(value);
                     })

                });
        },
        

        sendOtp() {
            if (!this.validateForm) return false
            
            var request={
                phoneNo:this.phoneNumber,
                validate:true
            }
             this.$http.post(
                    "requestotp",
                    JSON.stringify(request),
                     {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    if(response.data.statusCode==200){
                        this.popupActive=true;
                    }else{
                        this.errorMessage=response.data.message;
                    }
                    }).catch(error=>{
                    console.log(error);
                    })
          
           
        },
         registerClinic() {
             this.popupActive=false;
             var request={
                clinicId:"New",
                userId:"New",
                userName:this.username,
                clinicName:this.clinicname,
                area:this.areaId,
                type:this.clinicTypeId,
                phoneNumber:this.phoneNumber,
                address:"",
                city:"",
                pinCode:"",
                imageUrl:"",
                onlineBooking:false,
                ivrsService:false,
                status:true,
                map:"",
                password:this.password
             }
             this.$http.post(
                    "registerClinic",
                    JSON.stringify(request),
                     {
                        headers: {
                            "Content-Type": "application/json",
                            PhoneNumber:this.phoneNumber,
                            OTP:this.otp
                        }
                    })
                .then(response => {
                    
                     this.notify();
                     this.$router.push({path:'login'});
                }).catch(error=>{
                 
                    this.popupActive=true;
                    this.otpError='Invalid Otp'
                })
          
           
        },
        notify() {
            this.$vs.notify({
                title: 'Success',
                text: 'Successfully Registered',
                iconPack: 'feather',
                 icon: 'icon-check',
                 position: 'top-center',
                color: 'success'
            });
        },
    }
}
</script>
